
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import type { User } from "@supabase/supabase-js";
import type { Signature } from "@/types/supabase";
import { SignatureService } from "@/services/SignatureService";
import { useSignatureSubscription } from "./signatures/useSignatureSubscription";
import { useSignatureMutations } from "./signatures/useSignatureMutations";

export const useSignatures = (user: User | null) => {
  const [signatures, setSignatures] = useState<Signature[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  // Set up signature subscription and mutations 
  const { saveSignature, deleteSignature } = useSignatureMutations(user, signatures, setSignatures);
  useSignatureSubscription(user, setSignatures);

  return {
    signatures,
    isLoading,
    error,
    saveSignature,
    deleteSignature
  };
};
